import { atom, RecoilState } from "recoil";
import { CognitoIdToken, RefreshToken } from "@goodfill/backend-api-client";
import { UserData } from "./App/backendApi/amplifyGraphQl/CustomGetUserData/UserData";
import { PricedBond, PricedBondsMap } from "./App/bonds/PricedBond";
import { CorporateBondId, UserId } from "@goodfill/domain-properties";
import { recoilPersist } from "recoil-persist";
import {
  CustomerApplication,
  CustomerApplicationDeepPartial,
  CustomerApplicationSubmission,
} from "@goodfill/domain-customer-application-types";

export const isGlobalStateLoadingState = atom({
  key: "isGlobalStateLoadingState",
  // Important to have default true to prevent screen from flickering
  default: true,
});

// User

export interface User {
  userId: UserId;
  username: string;
}

export interface UserAuthState {
  user: User;
  idToken: CognitoIdToken;
  refreshToken: RefreshToken;
}

const { persistAtom: userAuthStatePersistAtom } = recoilPersist({ key: "user-auth-state" });
export const userAuthState: RecoilState<UserAuthState | null> = atom({
  key: "userAuthState",
  default: null as UserAuthState | null,
  effects_UNSTABLE: [userAuthStatePersistAtom],
});

export const userDataState = atom({
  key: "userDataState",
  default: null as UserData | null,
});

export const userCustomerApplicationState = atom({
  key: "userCustomerApplicationState",
  default: null as CustomerApplicationSubmission | null,
});

export const userCustomerApplicationWizardState = atom({
  key: "userCustomerApplicationWizardState",
  default: null as CustomerApplicationDeepPartial<CustomerApplication> | null,
});

export const hasUserBeenRedirectedToTheCustomerApplicationState = atom({
  key: "hasUserBeenRedirectedToTheCustomerApplicationState",
  default: false,
});

// Bonds

export const pricedBondState = atom({
  key: "pricedBondState",
  default: new Map<CorporateBondId, PricedBond>() as PricedBondsMap,
});

export const filterPopupDockedState = atom({
  key: "filterPopupDockedState",
  default: false,
});

// Favorite bonds

export const isGlobalFavoriteBondLoading = atom({
  key: "isGlobalFavoriteBondLoading",
  default: false,
});

export const userFavoriteBondsState = atom({
  key: "userFavoriteBondsState",
  default: [] as CorporateBondId[],
});
